module.exports = __webpack_public_path__ + "static/media/play-store.02b028d1.png";